import * as Sentry from '@sentry/react';

export const initializeSentry = () => {
  Sentry.init({
    dsn: 'https://6f929523d8567464b6a81c2173b857b1@o4508887880826880.ingest.de.sentry.io/4508888000036944',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
};
